var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram_1384015_1_",
    "data-name": "instagram_1384015 (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.176,
    height: 23.176,
    viewBox: "0 0 23.176 23.176",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M211.436,209.218A2.218,2.218,0,1,1,209.218,207,2.218,2.218,0,0,1,211.436,209.218Zm0,0",
    transform: "translate(-197.63 -197.63)",
    fill: "#113f3d"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M146.127,137.019a2.2,2.2,0,0,0-1.263-1.263,3.682,3.682,0,0,0-1.235-.229c-.7-.032-.912-.039-2.689-.039s-1.987.007-2.689.039a3.684,3.684,0,0,0-1.235.229,2.2,2.2,0,0,0-1.263,1.263,3.683,3.683,0,0,0-.229,1.236c-.032.7-.039.912-.039,2.689s.007,1.987.039,2.689a3.681,3.681,0,0,0,.229,1.235,2.2,2.2,0,0,0,1.263,1.263,3.677,3.677,0,0,0,1.236.229c.7.032.912.039,2.689.039s1.987-.007,2.689-.039a3.677,3.677,0,0,0,1.236-.229,2.2,2.2,0,0,0,1.263-1.263,3.684,3.684,0,0,0,.229-1.235c.032-.7.039-.912.039-2.689s-.007-1.987-.039-2.689A3.676,3.676,0,0,0,146.127,137.019Zm-5.187,7.341a3.417,3.417,0,1,1,3.417-3.417A3.417,3.417,0,0,1,140.94,144.361Zm3.552-6.17a.8.8,0,1,1,.8-.8A.8.8,0,0,1,144.492,138.19Zm0,0",
    transform: "translate(-129.352 -129.356)",
    fill: "#113f3d"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M11.588,0A11.588,11.588,0,1,0,23.176,11.588,11.589,11.589,0,0,0,11.588,0ZM18.2,14.331a4.882,4.882,0,0,1-.309,1.615,3.4,3.4,0,0,1-1.946,1.946,4.885,4.885,0,0,1-1.615.309c-.71.032-.936.04-2.743.04s-2.034-.008-2.744-.04a4.885,4.885,0,0,1-1.615-.309,3.4,3.4,0,0,1-1.946-1.946,4.881,4.881,0,0,1-.309-1.615c-.033-.71-.04-.936-.04-2.744s.008-2.034.04-2.743a4.882,4.882,0,0,1,.309-1.615A3.4,3.4,0,0,1,7.229,5.283a4.887,4.887,0,0,1,1.615-.309c.71-.032.936-.04,2.743-.04s2.034.008,2.743.04a4.888,4.888,0,0,1,1.615.309,3.4,3.4,0,0,1,1.946,1.946A4.881,4.881,0,0,1,18.2,8.845c.032.71.04.936.04,2.743S18.235,13.622,18.2,14.331Zm0,0",
    fill: "#113f3d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.96287fe52cdcacc5ba5550bae2b3128d.svg";
export { ForwardRef as ReactComponent };